import { useCallback, useEffect, useState } from 'react';
import { toQueryParams } from './AuditFiltersBar';

const LIMIT = 50;

export default function useAuditList(fetcher, deps = []) {
  const [filters, setFilters] = useState({});
  const [offset, setOffset] = useState(0);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = useCallback(async (nextOffset = 0, nextFilters = filters) => {
    setLoading(true);
    setError(null);
    try {
      const params = { ...toQueryParams(nextFilters), limit: LIMIT, offset: nextOffset };
      const resp = await fetcher(params);
      setRows(resp?.items || []);
      setOffset(nextOffset);
    } catch (e) {
      setError(e?.response?.data?.detail || e?.message || 'error');
      setRows([]);
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetcher, ...deps]);

  useEffect(() => {
    load(0, filters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    filters,
    setFilters: (next) => { setFilters(next); load(0, next); },
    offset,
    limit: LIMIT,
    rows,
    loading,
    error,
    next: () => load(offset + LIMIT, filters),
    prev: () => load(Math.max(0, offset - LIMIT), filters),
    reload: () => load(offset, filters),
  };
}
